import React, { useState } from "react";

import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { Checkbox, ListItemText } from "@material-ui/core";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { i18n } from "../../translate/i18n";

const TicketsQueueSelect = ({
	userQueues,
	selectedQueueIds = [],
	onChange,
	style,
}) => {
	const [anchorEl, setAnchorEl] = useState(null);

	const handleOpen = (e) => {
		setAnchorEl(e.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleToggleQueue = (queueId) => {
		const idx = selectedQueueIds.indexOf(queueId);
		const next =
			idx === -1
				? [...selectedQueueIds, queueId]
				: selectedQueueIds.filter((id) => id !== queueId);
		onChange(next);
	};

	return (
		<>
			<IconButton
				size="small"
				onClick={handleOpen}
				aria-label={i18n.t("ticketsQueueSelect.placeholder")}
				style={style}
			>
				<MoreVertIcon style={{ fontSize: 20 }} />
			</IconButton>
			<Menu
				anchorEl={anchorEl}
				open={Boolean(anchorEl)}
				onClose={handleClose}
				anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
				transformOrigin={{ vertical: "top", horizontal: "left" }}
				getContentAnchorEl={null}
			>
				{userQueues?.length > 0 ? (
					userQueues.map((queue) => (
						<MenuItem
							dense
							key={queue.id}
							onClick={() => handleToggleQueue(queue.id)}
						>
							<Checkbox
								style={{ color: queue.color }}
								size="small"
								color="primary"
								checked={selectedQueueIds.indexOf(queue.id) > -1}
							/>
							<ListItemText primary={queue.name} />
						</MenuItem>
					))
				) : (
					<MenuItem disabled>
						<ListItemText primary={i18n.t("ticketsQueueSelect.placeholder")} />
					</MenuItem>
				)}
			</Menu>
		</>
	);
};

export default TicketsQueueSelect;
